module.exports = __webpack_public_path__ + "static/media/rtl-access-modal.ed111e87.png";